/** Objection handling, and the cheapest SEO content on the page. */

export const faq = [
  {
    id: "faq-setup",
    question: "כמה זמן לוקח להקים את הסטודיו במערכת?",
    answer:
      "בדרך כלל כמה ימי עבודה. אנחנו מקימים את הלו״ז, סוגי האימונים, הקבוצות והמנויים לפי איך שהסטודיו שלכם עובד, ואתם רק מאשרים. אפליקציה ממותגת לוקחת קצת יותר, בגלל תהליך האישור של חנויות האפליקציות.",
  },
  {
    id: "faq-branded",
    question: "מה זה אפליקציה ממותגת?",
    answer:
      "אפליקציה נפרדת משלכם בחנויות, עם השם, הלוגו, הצבעים והתמונות של הסטודיו. המתאמנות מחפשות את שם הסטודיו ומורידות אותה — לא מערכת גנרית עם הלוגו שלנו.",
  },
  {
    id: "faq-industries",
    question: "לאיזה סוגי סטודיו אפלאטס מתאימה?",
    answer:
      "סטודיו שעובד באימונים ומנויים: פילאטיס, ספינינג, יוגה, אימוני כוח ופונקציונליים, קרוספיט וסטודיו לתנועה. אם יש לכם לו״ז שיעורים וכרטיסיות — היא מתאימה.",
  },
  {
    id: "faq-groups",
    question: "אפשר להגביל מספר מקומות בשיעור?",
    answer:
      "כן. לכל קבוצת אימון יש מספר מקומות, והמתאמנות נרשמות עד שהוא מתמלא. מי שלא הספיקה נכנסת לרשימת המתנה ומקבלת התראה אוטומטית ברגע שמתפנה מקום.",
  },
  {
    id: "faq-subscriptions",
    question: "איך זה עובד עם כרטיסיות ומנויים?",
    answer:
      "הכרטיסייה מתנקבת אוטומטית בכל אימון. אתם והמתאמנת רואים כמה אימונים נשארו ומתי המנוי נגמר, ומקבלים התראה לפני הסיום.",
  },
  {
    id: "faq-clients",
    question: "המתאמנות שלי צריכות להוריד אפליקציה?",
    answer:
      "כן, וזה לוקח פחות מדקה. אחרי ההורדה הן נרשמות לאימון בכמה הקשות, מקבלות תזכורות ורואות את הכרטיסייה שלהן — בלי להתקשר אליכם.",
  },
  {
    id: "faq-data",
    question: "של מי המידע על המתאמנות?",
    answer:
      "שלכם. רשימת המתאמנות, ההיסטוריה והנתונים של הסטודיו נשארים שלכם, ואפשר לקבל אותם בכל שלב.",
  },
  {
    id: "faq-cancel",
    question: "אפשר להפסיק מתי שרוצים?",
    answer:
      "כן. אין התחייבות לתקופה ארוכה, ואפשר לעצור בסוף כל תקופת חיוב.",
  },
  {
    id: "faq-accessibility",
    question: "איך זה עוזר למתאמנות עם מוגבלויות?",
    answer:
      "הרשמה לאימון באפליקציה לא דורשת שיחת טלפון, וזה פותר חסם אמיתי למתאמנות עם ליקויי שמיעה ודיבור. בנוסף יש תמיכה בכמה שפות.",
  },
];
